import React from 'react';

import { onboardColors } from '../../theme/onboardTokens';

// The default Scout Talent logo, shown when the offer's entity has no usable logo.
const ScoutTalentLogo: React.FC = () => (
  <svg
    aria-label="Scout Talent"
    fill="none"
    height="32"
    role="img"
    viewBox="0 0 348.8 32"
    width="218"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#stlogo-clip)">
      <path
        d="M175.957 0.587461V7.13466H185.153V31.3244H192.255V7.13466H201.451V0.587461H175.957Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M216.92 12.9135L213.866 20.2935H219.93L216.92 12.9135ZM224.484 31.3238L222.182 25.7471H211.607L209.312 31.3238H202.079L216.494 0.33332H217.454L231.875 31.3238H224.477H224.484Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M237.528 31.3244V0.587461H244.637V24.828H256.922V31.3244H237.528Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M263.734 31.3244V0.587461H283.129V7.13466H270.844V12.6244H282.039V18.8312H270.844V24.828H283.129V31.3244H263.734Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M316.127 31.9103L297.649 15.2598V31.3236H290.547V0.166576L291.507 0L309.732 16.5201V0.586639H316.835V31.7871L316.127 31.9103Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M323.16 0.587461V7.13466H332.355V31.3244H339.458V7.13466H348.653V0.587461H323.16Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M12.2847 31.7437C8.81282 31.7437 4.63357 30.3604 1.95568 28.6004L3.91899 22.1474C6.38756 23.9508 9.6068 25.124 12.4868 25.124C14.9914 25.124 15.9587 23.9508 15.9587 22.4371C15.9587 20.8438 15.1647 19.7501 10.4802 17.8671C5.08831 15.6872 3.21162 12.5439 3.21162 8.8503C3.21162 4.35996 6.84949 0 13.9953 0C17.3373 0 20.7659 1.17328 22.5632 2.39001L20.7659 8.76339C19.0119 7.54662 16.168 6.25023 13.9953 6.25023C11.4041 6.25023 10.3575 7.46694 10.3575 8.72717C10.3575 10.7405 11.9022 11.4141 15.7493 13.0436C21.4732 15.4771 23.1911 18.2437 23.1911 22.1836C23.1911 27.094 19.6399 31.7437 12.2847 31.7437Z"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M45.147 31.7437C35.1573 31.7437 28.3868 24.9937 28.3868 15.8899C28.3868 6.78618 35.1573 0 45.147 0C48.6983 0 51.9609 1.05016 54.7182 2.68695L52.5456 8.72717C50.2935 7.46694 47.7456 6.67027 45.2337 6.67027C39.5098 6.67027 35.9585 10.1901 35.9585 15.8972C35.9585 21.6042 39.5098 25.124 45.2337 25.124C47.7456 25.124 50.5822 24.2839 52.8848 22.8572L55.0141 28.8973C52.3362 30.6573 48.6622 31.7509 45.1543 31.7509"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M75.8802 6.37336C71.0297 6.37336 67.774 10.3567 67.774 15.8899C67.774 21.4232 71.0367 25.4065 75.8802 25.4065C80.7231 25.4065 83.9858 21.3797 83.9858 15.8899C83.9858 10.4002 80.7231 6.37336 75.8802 6.37336ZM75.7574 31.7437C66.2726 31.7437 60.2096 24.9068 60.2096 15.8899C60.2096 6.87309 66.5612 0 76.046 0C85.5302 0 91.5935 6.83686 91.5935 15.8899C91.5935 24.943 85.1986 31.7437 75.7503 31.7437"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M110.904 31.4901C102.668 31.4901 98.0774 27.0433 98.0774 18.4899V0.253437H105.18V17.9902C105.18 22.3501 107.021 24.9937 111.07 24.9937C115.119 24.9937 116.916 22.3501 116.916 17.9902V0.253437H124.019V18.4972C124.019 27.0505 119.125 31.4973 110.897 31.4973"
        fill={onboardColors.brand.tealInk}
      />
      <path
        d="M131.192 0.507852V7.04781H140.388V31.2448H147.49V7.04781H156.687V0.507852H131.192Z"
        fill={onboardColors.brand.tealInk}
      />
    </g>
    <defs>
      <clipPath id="stlogo-clip">
        <rect fill="white" height="32" width="348.8" />
      </clipPath>
    </defs>
  </svg>
);

export default ScoutTalentLogo;
